<template>
  <div class="step-header-container" v-if="vista && vista.config">
    <step-counter v-if="vista.config.paso" :paso="vista.config.paso" />
    <wrap-container>
      <h1
        id="titulo"
        class="titulo p32 medium oscuro"
        v-if="titulo"
        v-html="titulo"
      />
      <p
        id="subtitulo"
        class="titulo oscuro"
        v-if="subtitulo"
        v-html="subtitulo"
      />
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import StepCounter from "@/components/core/StepCounter";

export default {
  name: "StepHeader",
  components: { StepCounter, WrapContainer },
  data() {
    return {
      vista: null,
      isExceeded: false
    };
  },
  computed: {
    titulo() {
      const origin = this.$store.state.origen;
      if (this.isExceeded && this.vista.config.tituloExceded) {
        return this.vista.config.tituloExceded;
      }
      if (process.env.VUE_APP_CAMP === "ofertaDigital") {
        if (
          (origin === "REFEM" || origin === "REFCL") &&
          this.vista.config.referidoEmprendedor?.titulo
        ) {
          return this.vista.config.referidoEmprendedor.titulo;
        }
        if (
          this.vista.config.tituloPF &&
          this.$store.getters.getPaso1().esPF === true
        ) {
          return this.vista.config.tituloPF;
        }
      }
      return this.vista.config.titulo;
    },
    subtitulo() {
      const origin = this.$store.state.origen;
      if (this.isExceeded && this.vista.config.subtituloExceded) {
        return this.vista.config.subtituloExceded;
      } else if (
        process.env.VUE_APP_CAMP === "ofertaDigital" &&
        (origin === "REFEM" || origin === "REFCL") &&
        this.vista.config.referidoEmprendedor?.subtitulo
      ) {
        return this.vista.config.referidoEmprendedor.subtitulo;
      } else {
        return this.vista.config.subtitulo;
      }
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
    this.$store.watch(
      this.$store.getters.getIsExceeded,
      isExceeded => {
        this.isExceeded = isExceeded;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
#titulo {
  margin-bottom: 12px;
  line-height: 1.2em;
}

#subtitulo {
  margin-bottom: 16px;
  line-height: 1.6em;
}

.step-header-container {
  margin-bottom: 40px;
}
</style>
